<template>
    <div class="fixed-header">
        <div class="popup-tabs">
            <button v-for="t in visibleTabs" :key="t.key" class="tab" :class="{ active: tab === t.key }" @click="$emit('active-tab', t.key)">
                {{ t.label }}
            </button>
        </div>

        <div v-if="isListMode" class="search-container">
            <div class="search-row">
                <ans-input
                    id="Keyword"
                    v-model="data.Keyword"
                    type="text"
                    :max-length="100"
                    placeholder="キーワードで検索..."
                    item-class="width-400-px"
                    input-class="custom-border"
                    is-enable-i-m-e
                />
                <ans-date-picker id="TargetDate" v-model="data.TargetDate" input-class="custom-border" :item-class="'width-120-px'" :maxLength="8" />
                <button class="search-btn" @click="$emit('search')">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                        ></path>
                    </svg>
                </button>
                <button class="clear-btn" @click="$emit('clear-search')">クリア</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'MessageHeaderSection',
    props: {
        visibleTabs: { type: Array, default: () => [] },
        tab: { type: String, default: '' },
        isListMode: { type: Boolean, default: false }
    },
    computed: { ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']), ...mapState('MNG_DM_Message_Store', ['data', 'options']) }
};
</script>
